export const LANGUAGE_STORAGE_KEY = "moone_language";

export const SUPPORTED_LANGUAGES = [
  "cs",
  "en",
  "pl",
  "sk",
  "vi",
  "de",
] as const;

export type Language = (typeof SUPPORTED_LANGUAGES)[number];

// Language mapping for browser locales to our supported languages
export const LANGUAGE_MAPPING: Record<string, Language> = {
  // Czech
  cs: "cs",
  "cs-CZ": "cs",
  cz: "cs",
  // English
  en: "en",
  "en-US": "en",
  "en-GB": "en",
  "en-CA": "en",
  "en-AU": "en",
  // Polish
  pl: "pl",
  "pl-PL": "pl",
  // Slovak
  sk: "sk",
  "sk-SK": "sk",
  // Vietnamese
  vi: "vi",
  "vi-VN": "vi",
  // German
  de: "de",
  "de-DE": "de",
  "de-AT": "de",
  "de-CH": "de",
};

export const LANGUAGE_TO_ZOD_LOCALE_MAP = {
  cs: "cs",
  en: "en",
  sk: "cs", //Slovak unsupported yet by zod,fallback to Czech
  pl: "pl",
  vi: "vi",
  de: "de",
} as const satisfies Record<Language, string>;
